module.exports = "images/9ecdcf81b22cc26c370c9ac4eda65fc4.png";